export const DATE_FORMAT = {
  defaultPipe: 'MM/dd/yyyy',
	timezoneEst: 'EDT',
};

export const DEFAULT_DATE = '1970-01-01 00:00:00';
